module.exports = "/build/images/icons-famiglia.a0ecb718.svg";